import React, { createContext, useContext, useEffect, useState } from "react";
(window as any).global = window;

const CustomBackgroundContext = createContext<{
    settings: { enabled: boolean, url: string },
    setSettings: React.Dispatch<React.SetStateAction<{ enabled: boolean, url: string }>>
}>({
    settings: { enabled: false, url: "" },
    setSettings: () => { }
});

export const CustomBackgroundProvider = ({ children }: { children: React.ReactNode }) => {
    const [settings, setSettings] = useState(JSON.parse(localStorage.getItem("customBackground") || "{}"));
    useEffect(() => {
        const appDiv = document.getElementById("background");
        let get2ndDiv = document.getElementsByTagName("div")[1];
        if (get2ndDiv) {
            get2ndDiv.classList.remove('bg-gradient-to-r', 'from-brand-darkest', 'to-brand-darkest2');
        }
        if (settings.enabled && settings.url) {
            if (appDiv) {
                appDiv.style.background = `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('${settings.url}')`;
                appDiv.style.height = "100vh";
                appDiv.style.width = "100vw";
                appDiv.style.backgroundSize = "cover";
                appDiv.style.backgroundPosition = "center";
            }
            const updateDivsOpacity = () => {
                const divs = document.body.querySelectorAll("div");
                divs.forEach(div => {
                    const classes = div.className.split(" ");
                    for (const className of classes) {
                        if (className.startsWith("bg-brand-")) {
                            div.style.opacity = "0.85";
                            break;
                        }
                    }
                });
            };
            updateDivsOpacity();
            const observer = new MutationObserver(updateDivsOpacity);
            observer.observe(document.body, { childList: true, subtree: true });
            return () => observer.disconnect();
        } else {
            if (appDiv) {
                appDiv.style.background = "";
            }
            const divs = document.querySelectorAll("div");
            divs.forEach(div => {
                const classes = div.className.split(" ");
                for (const className of classes) {
                    if (className.startsWith("bg-brand-")) {
                        div.style.opacity = "1";
                        break;
                    }
                }
            });
            let findDiv = document.querySelectorAll('div')[1];
            if (findDiv) {
                findDiv.classList.add('bg-gradient-to-r', 'from-brand-darkest', 'to-brand-darkest2');
            }
        }
        localStorage.setItem("customBackground", JSON.stringify(settings));
    }, [settings]);


    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "F2") {
                setSettings({ ...settings, enabled: !settings.enabled });
                localStorage.setItem("customBackground", JSON.stringify({ ...settings, enabled: !settings.enabled }));
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [settings]);

    return (
        <CustomBackgroundContext.Provider value={{ settings, setSettings }}>
            {children}
        </CustomBackgroundContext.Provider>
    );
};

export function useCustomBackground() {
    return useContext(CustomBackgroundContext);
}